<script setup>
import { defineComponent } from 'vue'
import {useRoute} from "vue-router";
import Redirect from "@/components/Redirect.vue";
const route = useRoute()
defineComponent({
  name: 'SuccesAchatNFC',
})
</script>

<template>
  <div class="container text-center">
    <h1 class="py-3 py-sm-5">Merci d'avoir rechargé votre carte</h1>
    <p>Votre commande n° {{route.query.numeroCommande}} a été enregistrée.</p>
    <p>
      Le réseau Riv'Connect vous remercie pour votre commande.
      <br>
      Un email vient de vous être envoyé confirmant votre nouvel abonnement.
      <br>
      Bonne route à bord !
      <br><br>
      Keolis 3 Frontières
      <br>
      5 rue de l’Abbé Grégoire
      <br>
      57000 METZ
      <br>
      Téléphone : 03 87 34 60 00
      <br>
      E-mail : <a href="mailto:contact-rivconnect@keolis.com">contact-rivconnect@keolis.com</a>
    </p>
    <Redirect/>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/main";

</style>
